import { gql } from "@apollo/client";

import { assetsFragment } from "../fragments/assetsFragment";

export const getOrganizationAssets = gql`
    query getOrganizationAssets(
        $order: [String] = ["submittedAt_DESC", "publishedAt_DESC"]
        $organizationId: ID!
        $limit: Int
    ) {
        getMyLensesOrganizationAssets(input: { order: $order, organizationId: $organizationId, limit: $limit }) {
            ...Assets
        }
    }
    ${assetsFragment}
`;
